import { requestsLikeGenerate } from "../../../plugins/python/requestsLike.js";
const pythonHttpxAsync = {
  target: "python",
  client: "httpx_async",
  title: "HTTPX (Async)",
  generate(request, configuration) {
    let formattedReq = requestsLikeGenerate("await client", request, configuration);
    formattedReq = formattedReq.split("\n").map((line) => line.trim() === "" ? line : "    " + line).join("\n");
    return `with httpx.AsyncClient() as client:
${formattedReq}`;
  }
};
export {
  pythonHttpxAsync
};
//# sourceMappingURL=async.js.map
